'use client';

import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useRouter } from 'next/navigation';
import { useAuthStore } from '../hooks/auth';
import { useState } from 'react';
import useLoginModal from '@/app/hooks/useLoginModal';
import apiService from '@/app/services/apiService';
import { handleLogin } from '@/app/lib/actions';

interface CredentialResponse {
  credential?: string;
}

const API = (process.env.NEXT_PUBLIC_API_HOST || '').replace(/\/+$/, '');

const GoogleLoginButton = () => {
  const router = useRouter();
  const { setAuth, setUser } = useAuthStore();
  const login = useLoginModal();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    const id_token = credentialResponse.credential;
    if (!id_token) {
      setErrorMsg('Não foi possível obter o token do Google.');
      return;
    }
    setLoading(true);
    setErrorMsg(null);

    try {
      const { data } = await axios.post(
        `${API}/api/auth/google/`,
        { id_token },
        { withCredentials: true }
      );

      const { access, refresh, user } = data;
      setAuth({ accessToken: access, refreshToken: refresh });
      await handleLogin(user.pk, access, refresh);

      const userData = await apiService.getWithToken('/api/user/me/');
      setUser(userData);

      login.close();
      router.push('/landing');
      router.refresh();
    } catch (err) {
      console.error('Erro ao fazer login com Google', err);
      setErrorMsg('Erro ao fazer login com Google. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="google-btn-wrap w-full mx-auto px-2" 

        style={{ pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1 }}
      >
        <GoogleLogin onSuccess={handleSuccess} onError={() => setErrorMsg('Login cancelado.')} />
      </div>

      <style jsx global>{`
        .google-btn-wrap iframe,
        .google-btn-wrap div[role="button"] {
          width: 100% !important;
          max-width: 100% !important;
        }
      `}</style>

      {errorMsg && (
        <div className="mt-2 text-red-600 font-semibold text-center">
          {errorMsg}
        </div>
      )}
    </>
  );
};

export default GoogleLoginButton;
